import * as React from 'react';
import styled from 'styled-components';

export const Itunes: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="112" height="32" viewBox="0 0 112 32" {...props}>
    <path d="M28 23.7c-0.8 1.6-1.1 2.4-2.1 3.8 -1.4 2-3.3 4.5-5.7 4.5 -2.1 0-2.7-1.3-5.6-1.3 -2.9 0-3.5 1.3-5.6 1.3 -2.4 0-4.2-2.3-5.6-4.3C-0.5 22.1-0.9 15.5 1.5 12c1.7-2.5 4.3-4 6.8-4 2.5 0 4.1 1.3 6.2 1.3 2 0 3.3-1.3 6.2-1.3 2.2 0 4.6 1.2 6.3 3.2C21.5 14.1 22.4 21.6 28 23.7L28 23.7z" />
    <path d="M19.3 5.4C20.4 4 21.2 2 20.9 0c-1.8 0.1-3.9 1.3-5.2 2.7 -1.1 1.3-2 3.3-1.7 5.3C16.1 8.1 18.1 6.9 19.3 5.4L19.3 5.4z" />
    <path d="M36.6 14.2c0 1.2-0.9 2.1-2.3 2.1 -1.4 0-2.3-1-2.2-2.1 0-1.2 0.9-2.2 2.3-2.2C35.7 12 36.6 12.9 36.6 14.2z" />
    <rect x="32.1" y="18" width="4.3" height="13.7" />
    <polygon points="43.8 16.4 38.6 16.4 38.6 12.8 53.3 12.8 53.3 16.4 48.1 16.4 48.1 31.7 43.8 31.7 " />
    <path d="M67.2 31.7h-3.8l-0.2-1.9h-0.1c-0.5 0.8-1.9 2.2-4.4 2.2 -2.8 0-4.9-1.7-4.9-6v-8h4.4v7.4c0 2 0.7 3.2 2.2 3.2 1.2 0 1.9-0.8 2.2-1.5 0.1-0.3 0.1-0.6 0.1-0.9V18h4.4v9.3C67.1 27.3 67.1 30.5 67.2 31.7z" />
    <path d="M70.4 18h3.8l0.2 1.9h0.1c0.6-0.9 2-2.2 4.3-2.2 2.8 0 5 1.9 5 5.9v8.1h-4.3v-7.6c0-1.8-0.6-3-2.2-3 -1.2 0-1.9 0.8-2.2 1.6 -0.1 0.3-0.2 0.7-0.2 1.1v7.9h-4.3C70.6 31.7 70.5 19.2 70.4 18z" />
    <path d="M99.7 24.5c0-3.4-1.7-6.8-6.2-6.8 -4.8 0-7 3.8-7 7.3 0 4.3 2.7 7 7.4 7 1.9 0 3.6-0.3 5-0.9l-0.6-2.9c-1.2 0.4-2.4 0.6-3.8 0.6 -2 0-3.8-0.8-3.9-2.6l9 0C99.6 25.9 99.7 25.2 99.7 24.5zM90.5 23.3c0.1-1.2 0.9-2.8 2.7-2.8 2 0 2.4 1.7 2.4 2.8H90.5z" />
    <path d="M102.2 28c0.8 0.5 2.4 1 3.7 1 1.3 0 1.9-0.4 1.9-1.2s-0.4-1-2-1.6c-2.9-1-4-2.5-4-4.1 0-2.6 2.2-4.5 5.7-4.5 1.6 0 3.1 0.4 3.9 0.8l-0.8 2.9c-0.6-0.3-1.8-0.8-3-0.8 -1.1 0-1.7 0.4-1.7 1.1 0 0.6 0.5 1 2.2 1.6 2.6 0.9 3.8 2.2 3.8 4.2 0 2.6-2 4.5-6 4.5 -1.8 0-3.4-0.4-4.5-1L102.2 28 102.2 28z" />
  </svg>
);

export default styled(Itunes)`
  & > path,
  & > rect,
  & > polygon {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
